module.exports = __webpack_public_path__ + "img/three-man.1ad514ae.png";